<ngx-spinner
  bdColor="rgba(0, 0, 0, 1)"
  size="medium"
  color="#fff"
  type="square-spin"
  [fullScreen]="true"
>
  <p class="text-white">Loading...</p>
</ngx-spinner>

<div class="h-full w-full">
  <router-outlet></router-outlet>
</div>
